import { useMutation } from '@tanstack/react-query'

import useSessionLocalStorage from '~/App/Auth/hooks/useSessionLocalStorage'

import { deleteFlow } from '../api'

const useFinishFlow = () => {
  const [session] = useSessionLocalStorage()

  return useMutation({
    mutationKey: ['finishFlow'],
    mutationFn: async () => {
      if (!session?.id) {
        throw new Error('Session ID is required to finish flow')
      }
      return deleteFlow(session.attributes.app_id)
    },
  })
}

export default useFinishFlow
